module.exports = __webpack_public_path__ + "media/images/img_voice3-c74f6edb8f68c98b0754c29e245666c2.jpg";